import $ = require("jquery");
import _ = require("underscore");
import Utils = require("../utils");
import resx = require("../i18n/common");

import Marionette = require("backbone.marionette");
import Collection = require("../collections/base-collection");
import Model = require("../models/base-model");
import Portal = require("portal-gis");
import Controller = require("../controls/controller");

const log = Utils.log;

class View<T> extends Marionette.LayoutView<Model<T>> {
  collection: Collection<T>;
  controller: Controller;

  static about = `
base view
    `;

  static options = <any>{
    text: {
      about: "title to assign to this view",
    },
  };

  constructor(controller: Controller, options: Backbone.ViewOptions<Model<T>> = {}) {
    this.controller = controller;
    options = this.execute(options) || options;
    super(options); // needs to call execute on derived before initializing base :(

    log(`constructing view ${this.className}`);

    if (this.collection) {
      this.collection.on("change", (args) => {
        this.refreshItem(args);
      });
      this.collection.on("add", (args) => {
        this.refreshItem(args, {
          exists: false,
        });
      });
    }
  }

  /**
    Allow template to get properties from the view
    */
  templateHelpers() {
    let that = this;
    return {
      gimme: (key: string) => that[key],
    };
  }

  refreshItem(model: Model<T>, options = { exists: true }) {
    // to be shadowed
  }

  get mediator() {
    return this.controller.mediator;
  }

  public execute(options: Backbone.ViewOptions<Model<T>>) {
    return options;
  }

  onBeforeDestroy() {
    log("destroying view: ", this.className);
  }

  onBeforeRender() {
    log("before rendering view: ", this.className);
  }

  onRender() {
    log("rendering view: ", this.className);
    if (this.controller && this.controller.configuration && this.controller.configuration.text) {
      let options = Utils.asDictionary(this.controller.configuration.Options.Values);
      let showTitle = true;
      Utils.ifOption(options, "text", (text) => (showTitle = "false" !== text));
      if (showTitle) {
        this.$el.prepend(`<label class="view-title">${Utils.translate(this.controller.configuration.text)}</label>`);
      }
    }
    this.collection && this.renderItems(this.collection.map((model) => model.data));
    this.model && this.renderItem(this.model.data);
  }

  onShow() {
    log("showing view: ", this.className);
  }

  renderItems(items: T[]) {
    items.forEach((item) => this.renderItem(item));
  }

  renderItem(item: T) {
    // to be shadowed by derived classes to do item-level handling
  }

  /**
   * TODO: This is also implemented in controls/view and needs to be consolidated
   * TODO: should support options/title to set the title on the button
   */
  addButton(command: Portal.CommandLeaf, container = this.$el) {
    var options = Utils.asDictionary(command.Options.Values);

    var buttonOptions = <any>{
      text: true,
      icons: false,
    };

    Utils.ifOption(options, "icon", (icon) => {
      buttonOptions.icons = { primary: `ui-icon ${icon}` };
    });

    Utils.ifOption(options, "text", (text) => (buttonOptions.text = "false" !== text));

    let label = command.text;

    Utils.ifOption(options, "template", (template) => {
      label = _.template(template)(resx);
    });

    let title = options["title"] || label;

    let button = $(`<button class="action-command ${command.id}" title="${title}">${label}</button>`)
      .button(buttonOptions)
      .click(() => {
        this.trigger("command", {
          command: command,
          controller: this.controller,
          view: this,
        });
      });

    Utils.ifOption(options, "radio-group", (cmdRadioGroup) => {
      this.mediator.on(
        "radio-group",
        (args: {
          out: {
            group: string;
            command: Portal.CommandLeaf;
          };
        }) => {
          if (cmdRadioGroup !== args.out.group) return;
          if (command === args.out.command) {
            button.addClass("clicked");
          } else {
            button.removeClass("clicked");
          }
        }
      );
    });

    container.append(button);
    return button;
  }
}

export = View;
